module.exports = __webpack_public_path__ + "assets/10a8d487703c577d04a13e7b42f62f09.png";